import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
const setSearchParams = (url, params) => {
    try {
        const targetUrl = new URL(url || '');
        params.forEach(param => targetUrl.searchParams.set(param.key, param.value));
        return targetUrl.toString();
    }
    catch (error) {
        return '';
    }
};
const updateFieldsWithInventoryLeadParams = (fields, params) => {
    const clonedSitecoreFields = cloneDeep(fields);
    const ctaLink1 = setSearchParams(clonedSitecoreFields === null || clonedSitecoreFields === void 0 ? void 0 : clonedSitecoreFields.ctaLink1.href, params);
    const ctaLink2 = setSearchParams(clonedSitecoreFields === null || clonedSitecoreFields === void 0 ? void 0 : clonedSitecoreFields.ctaLink2.href, params);
    set(clonedSitecoreFields, 'ctaLink1.href', ctaLink1);
    set(clonedSitecoreFields, 'ctaLink2.href', ctaLink2);
    return clonedSitecoreFields;
};
export default updateFieldsWithInventoryLeadParams;
